export const integratorConfig = {
  integratorId: "adac:integrator",
};

export default integratorConfig;
